module.exports = __webpack_public_path__ + "img/5.5f6b4436.jpg";